import request from '@/utils/request'
import qs from 'qs'
export function getListMinibarReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/minibar',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListMinibarReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/minibar/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}

export function getReceptionestOptions(data = {}) {
  return request({
    // user_group
    // 12: FO-All, 42: ANNINH, 46: Sale-All
    url: '/config-service/v1/account?userGroupIds=12',
    method: 'get',
    params: data,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}

export function getProductOptions(data = {}) {
  return request({
    url: '/config-service/v1/room-service-group/products-by-code?code=COMPENSATION',
    method: 'get',
    params: data,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}

export function getProductMinibarOptions(data = {}) {
  return request({
    url: '/config-service/v1/room-service-group/products-by-code?code=MNB',
    method: 'get',
    params: data,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}

export function getProductLaundryOptions(data = {}) {
  return request({
    url: '/config-service/v1/room-service-group/products-by-code?code=Laundry',
    method: 'get',
    params: data,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
